import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import classNames from 'classnames';
import AddTeamMemberDialog from '../addTeamMemberDialog';
import AddLdapGroupMappingDialogContainer from '../addLdapGroupMappingDialogContainer';
import TeamsTabsContainer from '../teamsTabs';
import styles from './style.scss';

@inject('translationsStore', 'teamsStore') @observer
export default class TeamsMainContainer extends Component {
  
    render() {

        return (
            <div>
                <div className={classNames(styles.contentHeaderWrapper)}>
                    <div>
                        <div className={classNames(styles.contentTeamsHeader)}>
                            {this.props.title}
                            {
                                (this.props.teamsStore.selectedTabId == undefined || 
                                    this.props.teamsStore.selectedTabId == 1)
                                    ? <AddTeamMemberDialog />
                                        : <AddLdapGroupMappingDialogContainer />
                            }                            
                        </div>
                    </div>
                </div>
                <div className='content-body'>
                    <div>
                        <TeamsTabsContainer 
                            grid={this.props.grid}
                            teamId={this.props.teamsStore.selectedTeamId}
                            translationsStore={this.props.translationsStore}
                        />
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/teams/teamsMainContainer/index.jsx